'use client';

import { useEffect } from 'react';
import LogRocket from 'logrocket';

export default function LogRocketInitializer() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      LogRocket.init('fzyy3p/car');
    }
  }, []);

  return null;
}
